import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function tokenIssueBuilder() {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        There was a problem with your authorization token. Please try logging in
        to your brokerage again.
      </Body3>
    </td>
  );
}
